import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Select,
  Stack,
  Textarea,
  useToast,
  VStack,
  Icon,
  HStack,
  InputGroup,
  InputLeftElement,
  Text,
} from '@chakra-ui/react';
// import { MdPersonAddAlt1 } from 'react-icons/md';
import { sendEmployeeInvite } from '../hooks/employees';
import { useParams } from 'react-router-dom';
import { EmailIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import { AtSignIcon, SettingsIcon } from 'lucide-react';

export default function InviteEmployeePage() {
  const { orgId } = useParams();
  const [email, setEmail] = useState('');
  const [role, setRole] = useState('');
//   const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const toast = useToast();

  const handleInvite = async () => {
    if (!email || !role) {
      toast({
        title: 'Missing fields',
        description: 'Email and Role are required.',
        status: 'warning',
        duration: 4000,
        isClosable: true,
      });
      return;
    }

    try {
      setIsSubmitting(true);
      // Simulate API call
      await new Promise((res) => setTimeout(res, 1000));
      if(orgId){
        await sendEmployeeInvite(orgId, email, role);
      }

      toast({
        title: 'Invitation Sent',
        description: `Invitation sent to ${email}`,
        status: 'success',
        duration: 5000,
        isClosable: true,
      });

      // Reset form
      setEmail('');
      setRole('');
    //   setMessage('');
    } catch (error) {
      toast({
        title: 'Error',
        description: 'Failed to send invitation.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    // <Container maxW="lg" py={10}>
    //   <Stack spacing={6} bg="white" p={8} borderRadius="md" shadow="md">
    //     <VStack spacing={1} align="start">
    //       <HStack>
    //         <Heading size="lg">Invite a New Employee</Heading>
    //       </HStack>
    //     </VStack>

    //     <FormControl isRequired>
    //       <FormLabel>Email Address</FormLabel>
    //       <Input
    //         type="email"
    //         placeholder="employee@example.com"
    //         value={email}
    //         onChange={(e) => setEmail(e.target.value)}
    //       />
    //     </FormControl>

    //     <FormControl isRequired>
    //       <FormLabel>Role</FormLabel>
    //       <Select
    //         placeholder="Select role"
    //         value={role}
    //         onChange={(e) => setRole(e.target.value)}
    //       >
    //         <option value='manager'>Manager</option>
    //         <option value="sales">Sales Representative</option>
    //         <option value="marketing">Marketing</option>
    //         <option value="finance">Finance</option>
    //         <option value="support">Support Staff</option>
    //         <option value="other">Other</option>
    //       </Select>
    //     </FormControl>

    //     <Button
    //       onClick={handleInvite}
    //       isLoading={isSubmitting}
    //       loadingText="Sending Invite..."
    //       colorScheme="green"
    //       bg="#006400"
    //       _hover={{ bg: '#004d00' }}
    //     >
    //       Send Invitation
    //     </Button>
    //   </Stack>
    // </Container>
    <Container
      maxW="lg"
      py={16}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Stack
        spacing={6}
        bg={'whiteAlpha.900'}
        p={{ base: 6, md: 10 }}
        borderRadius="2xl"
        shadow="2xl"
        border="1px solid"
        borderColor={'gray.100'}
        backdropFilter="blur(10px)"
        _hover={{ transform: 'scale(1.01)', transition: '0.2s' }}
        width="full"
      >
        {/* Header */}
        <VStack spacing={1} align="start">
          <HStack spacing={3}>
            <Heading size="lg" color="green.700">
              Invite a New Employee
            </Heading>
          </HStack>
          <Text fontSize="md" color="gray.500">
            Enter the employee’s email and assign a role to send an invitation.
          </Text>
        </VStack>

        {/* Email Field */}
        <FormControl isRequired>
          <FormLabel fontWeight="medium" color="gray.700">
            Email Address
          </FormLabel>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <EmailIcon color="#006400" />
            </InputLeftElement>
            <Input
              type="email"
              placeholder="employee@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              rounded="lg"
              focusBorderColor="green.500"
              bg="gray.50"
              _placeholder={{ color: 'gray.400' }}
            />
          </InputGroup>
        </FormControl>

        {/* Role Field */}
        <FormControl isRequired>
          <FormLabel fontWeight="medium" color="gray.700">
            Role being Assigned:
          </FormLabel>
          <InputGroup>
            <InputLeftElement pointerEvents="none">
              <SettingsIcon color="green" />
            </InputLeftElement>
            <Select
              placeholder="Select role"
              value={role}
              onChange={(e) => setRole(e.target.value)}
              rounded="lg"
              focusBorderColor="green.500"
              bg="gray.50"
              pl="10" // ensures text doesn’t overlap with icon
            >
              <option value="manager">Manager</option>
              <option value="sales">Sales Representative</option>
              <option value="marketing">Marketing</option>
              <option value="finance">Finance</option>
              <option value="support">Support Staff</option>
              <option value="other">Other</option>
            </Select>
          </InputGroup>
        </FormControl>

        {/* Button */}
        <Button
          onClick={handleInvite}
          isLoading={isSubmitting}
          loadingText="Sending Invite..."
          size="lg"
          mt={2}
          rightIcon={<ArrowForwardIcon />}
          bgGradient="linear(to-r, green.600, green.700)"
          _hover={{
            bgGradient: 'linear(to-r, green.700, green.800)',
            transform: 'translateY(-2px)',
            shadow: 'md',
          }}
          rounded="lg"
          color="white"
          fontWeight="semibold"
        >
          Send Invitation
        </Button>
      </Stack>
    </Container>
  );
}
